import { createSelector } from 'reselect';
import {
    isConnectedSelector,
    lineLoadingSelector,
    selectedHubDataSelector,
    selectedHubSerialSelector,
} from '../selectors';

/**
 * Memoized selector that aggregates hub and application connection details for use in the expressions layout.
 *
 * Combines the selected hub serial, hub data, line loading status, and connection status into a single object.
 *
 * @function
 * @returns {Object} An object containing:
 *   @property {string|null} serial - The serial number of the selected hub, or null if not available.
 *   @property {HubData|null} controllerData - The data object of the selected hub, or null if not available.
 *   @property {boolean} lineLoading - Whether the line is loading.
 *   @property {boolean} isConnected - Whether the hub is connected.
 *
 * @example
 * const {
 *   serial,
 *   controllerData,
 *   lineLoading,
 *   isConnected
 * } = useSelector(expressionsLayoutSelector);
 */
export const expressionsLayoutSelector = createSelector(
    [selectedHubSerialSelector, selectedHubDataSelector, lineLoadingSelector, isConnectedSelector],
    (serial, controllerData, lineLoading, isConnected) => ({
        serial,
        controllerData,
        lineLoading,
        isConnected,
    }),
);
